import { defineComponent, computed, ref, watch, shallowRef, onMounted, createElementBlock, openBlock, createVNode, createTextVNode, unref, withCtx, createBlock, createCommentVNode, resolveDynamicComponent } from 'vue';
/* empty css                        */
import { MyClientOnly } from './basler-components.es384.js';

const _hoisted_1 = { class: "media-animation" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MediaAnimation",
  props: {
    media: {}
  },
  emits: ["animationLoaded"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const parseObject = (input) => {
      if (typeof input === "object" && input !== null) {
        return input;
      }
      try {
        JSON.parse(input);
        return JSON.parse(input);
      } catch (e) {
        console.warn("String is not valid JSON");
      }
      return {};
    };
    const getAnimationObject = computed(() => {
      return parseObject(props.media.animation);
    });
    const lottieRef = ref(null);
    const play = () => {
      if (lottieRef.value) {
        const t = lottieRef.value;
        t.play();
      }
    };
    const pause = () => {
      if (lottieRef.value) {
        const t = lottieRef.value;
        t.pause();
      }
    };
    watch(
      () => props.media.isPlaying,
      (newVal) => {
        if (newVal) {
          play();
        } else {
          pause();
        }
      }
    );
    const onAnimationLoad = () => {
      emit("animationLoaded");
    };
    const LazyLottieComponent = shallowRef(null);
    onMounted(async () => {
      const module = await import('vue3-lottie');
      LazyLottieComponent.value = module.Vue3Lottie;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(MyClientOnly), null, {
          default: withCtx(() => [
            LazyLottieComponent.value ? (openBlock(), createBlock(resolveDynamicComponent(LazyLottieComponent.value), {
              key: 0,
              ref_key: "lottieRef",
              ref: lottieRef,
              loop: _ctx.media.loop,
              "auto-play": _ctx.media.isPlaying === true,
              animationData: getAnimationObject.value,
              onOnAnimationLoaded: onAnimationLoad
            }, null, 40, ["loop", "auto-play", "animationData"])) : createCommentVNode("", true)
          ]),
          _: 1
        }),
        _cache[0] || (_cache[0] = createTextVNode(" > "))
      ]);
    };
  }
});

export { _sfc_main as default };
